import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';
import { Attachment } from './attachment';
import { StringToInteger } from './converters/string-to-integer-converter';

@JsonObject('RequiredDocument')
export class RequiredDocument extends Entity {
  @JsonProperty('name', String)
  public name?: string = undefined;
  @JsonProperty('displayOrder', StringToInteger)
  public displayOrder?: number = undefined;
  @JsonProperty('customerCanUpload', Boolean)
  public customerCanUpload?: boolean = undefined;
  @JsonProperty('uploadablePeriodically', Boolean)
  public uploadablePeriodically?: boolean = undefined;
  @JsonProperty('associatedToMachine', Boolean)
  public associatedToMachine?: boolean = undefined;
  @JsonProperty('active', Boolean)
  public active?: boolean = undefined;
  @JsonProperty('notes', String, true)
  public notes?: string = undefined;
  @JsonProperty('template', Attachment)
  public template?: Attachment = undefined;
  @JsonProperty('templateId', String, true)
  public templateId?: string = undefined;
  @JsonProperty('machineTypologies', [String], true)
  public machineTypologies?: string[] = undefined;

  public attachmentBody?: string = undefined;
  public attachmentFileName?: string = undefined;

  public get reqDocName(): string | undefined {
    return this.name;
  }
  public set reqDocName(value: string | undefined) {
    this.name = value;
  }
}
